import Link from 'next/link'
import React from 'react'

export const AirconQuickLinks = () => {
  return (
    <div className='px-4 text-white text-sm leading-7 bg-slate-700 py-10'>
        <div className='max-w-5xl mx-auto'>
            <h2 className='text-xl text-center uppercase'>
                <strong>Helpful Links</strong>
            </h2>
            <ul className='pt-10 pb-2 px-2 grid grid-cols-2 md:grid-cols-4 gap-y-4'>     
                <li className="flex justify-center">
                    <Link href={`/sg/aircon-servicing-singapore/aircon-servicing-price-singapore`} prefetch={false} className='text-amber-400'>
                        Servicing Price
                    </Link>
                </li>                          
                <li className="flex justify-center">
                    <Link href={`/sg/aircon-servicing-singapore/aircon-chemical-wash-and-overhaul`} prefetch={false} className='text-amber-400'>
                        Chemical Wash
                    </Link>
                </li>  
                <li className="flex justify-center">
                    <Link href={`/sg/aircon-servicing-singapore/aircon-gas-top-up`} prefetch={false} className='text-amber-400'>
                        Gas Top Up
                    </Link>
                </li>
                <li className="flex justify-center">
                    <Link href={`/sg/aircon-servicing-singapore/urgent-aircon-servicing`} prefetch={false} className='text-amber-400'>
                        Urgent Service
                    </Link>
                </li>
                <li className="flex justify-center">
                    <Link href={`/sg/aircon-servicing-singapore/aircon-repair`} prefetch={false} className='text-amber-400'>
                        Aircon Repair
                    </Link>
                </li> 
                <li className="flex justify-center">
                    <Link href={`/sg/aircon-servicing-singapore/annual-package`} prefetch={false} className='text-amber-400'>
                        Annual Package
                    </Link>
                </li>
                <li className="flex justify-center">
                    <Link href={`/sg/aircon-servicing-singapore/ac-printed-circuit-board-pcb`} prefetch={false} className='text-amber-400'>
                        PCB Replacement
                    </Link>
                </li>
                <li className="flex justify-center">
                    <Link href={`/sg/aircon-servicing-singapore/aircon-condenser-cleaning`} prefetch={false} className='text-amber-400'>
                        Condenser Cleaning
                    </Link>
                </li>
                <li className="flex justify-center">
                    <Link href={`/sg/aircon-servicing-singapore/ceiling-cassette-aircon-service`} prefetch={false} className='text-amber-400'>
                        Cassette A/C Service
                    </Link>
                </li>
                <li className="flex justify-center">
                    <Link href={`/sg/aircon-servicing-singapore/aircon-installation`} prefetch={false} className='text-amber-400'>
                        New Installation
                    </Link>
                </li>
                <li className="flex justify-center">
                    <Link href={`/sg/aircon-servicing-singapore/aircon-parts-replacement`} prefetch={false} className='text-amber-400'>
                        Parts Replacement
                    </Link>
                </li>
                <li className="flex justify-center">
                    <Link href={`/sg/blogs/hvac-services`} prefetch={false} className='text-amber-400'>
                        HVAC Blogs
                    </Link>
                </li>
            </ul>
        </div>
    </div>
  )
}
